<template>
  <div>
    <!-- MODAL -->
    <div class="modal show fade" style="display: block" v-if="show">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">

          <!-- HEADER -->
          <div class="modal-header">
            <h5 class="modal-title">IBAN Details</h5>
            <button type="button" class="close" @click="$emit('close')">
              <span>&times;</span>
            </button>
          </div>

          <!-- BODY -->
          <div class="modal-body scrollable-modal-body">

            <!-- Loader -->
            <div v-if="loading" class="text-center my-2">
              <span class="spinner-border spinner-border-sm"></span>
              <span class="ml-2">Saving...</span>
            </div>


            <!-- IBAN -->
            <div class="border rounded p-2 mb-2">
              <p><strong>IBAN</strong>: <span>{{ data?.iban }}</span></p>
            </div>

            <!-- ACCOUNT TITLE -->
            <div class="border rounded p-2 mb-2">
              <div class="d-flex align-items-center flex-nowrap">
                <p class="mb-0 mr-2 text-nowrap"><strong>Account Title:</strong></p>
                <input
                    type="text"
                    class="form-control w-100"
                    v-model="accountTitle"
                    :placeholder="data?.details?.accountTitle || 'Account Title'"
                />
                <small
                    v-if="submitted && !isAccountTitleValid"
                    class="text-danger"
                >
                  Account Title is required.
                </small>
              </div>
            </div>


            <!-- BANK DETAILS -->
            <div class="border rounded p-2 mb-2">
              <p><strong>Bank Name:</strong> {{ data?.details?.bankName }}</p>
              <p><strong>Swift Code:</strong> {{ data?.details?.swiftCode }}</p>
              <p><strong>Bank Code:</strong> {{ data?.details?.bankCode }}</p>
              <p><strong>Bank Account Title:</strong> {{ data?.details?.accountTitle }}</p>
              <p><strong>Wallet Contact ID :</strong> {{ data?.reference ?? 'N/A' }}</p>
            </div>

            <!-- AUDIT INFO -->
            <div class="border rounded p-2 mb-2">
              <p>
                <strong>Added By:</strong>
                {{ data?.added_by?.first_name }}
                {{ data?.added_by?.last_name }}
                ({{ data?.added_by?.email }})
              </p>

              <p v-if="data?.saved_by">
                <strong>Saved By:</strong>
                {{ data?.saved_by?.first_name }}
                {{ data?.saved_by?.last_name }}
                ({{ data?.saved_by?.email }})
              </p>

              <small class="text-muted">
                Created: {{ customFormatDateTime(data?.created_at) }}<br />
                Updated: {{ customFormatDateTime(data?.updated_at) }}
              </small>
            </div>

          </div>

          <!-- FOOTER -->
          <div class="modal-footer">
            <button
                type="button"
                class="btn btn-secondary"
                @click="$emit('close')"
            >
              Close
            </button>

            <!-- SAVE only if status === 2 -->
            <button
                v-if="data && data.status === 2"
                type="button"
                class="btn btn-success"
                :disabled="loading"
                @click="onSaveIban"
            >
              Save IBAN
            </button>

            <!-- UPDATE ACCOUNT TITLE -->
            <button
                v-if="data && data.status === 1 && hasAccountTitleChanged"
                type="button"
                class="btn btn-primary"
                :disabled="loading"
                @click="onUpdateAccountTitle"
            >
              Update Account Title
            </button>
          </div>

        </div>
      </div>
    </div>

    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  name: "IbanDetailsModal",
  props: {
    show: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isAccountTitleValid() {
      return this.accountTitle && this.accountTitle.trim().length > 0;
    },
    hasAccountTitleChanged() {
      return this.accountTitle !== this.originalAccountTitle;
    }
  },
  data() {
    return {
      accountTitle: "",
      originalAccountTitle: "",
      submitted: false
    };
  },
  watch: {
    show(val) {
      if (val) {
        this.accountTitle = this.data?.title || "";
        this.originalAccountTitle = this.data?.title || "";
        this.submitted = false;
      }
    }
  },
  methods: {
    onSaveIban() {

      this.submitted = true;

      if (!this.isAccountTitleValid) {
        return;
      }

      this.$emit("save", {
        iban: this.data?.iban,
        // saveWithCustomAccountTitle: false,
        accountTitle: this.accountTitle,
        fromDetails:true
      });
    },
    onUpdateAccountTitle() {

      this.submitted = true;

      if (!this.isAccountTitleValid) {
        return;
      }

      this.$emit("save", {
        iban: this.data?.iban,
        accountTitle: this.accountTitle,
        save:2,
        fromDetails:true
      });
    }
  }
};
</script>

<style scoped>
.modal {
  background: rgba(0, 0, 0, 0.2);
}
.scrollable-modal-body {
  max-height: 70vh; /* adjust height as needed */
  overflow-y: auto;
}
</style>
